import * as React from 'react';
import {EText, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {
  ExpressionEditor,
  updateExpressionEditorAction,
} from '@packages/systems/ExpressionEditor-utils';
import {
  TypeImplementation,
  Expressions,
  withMeta,
  Plugins,
} from '@packages/systems/wfdl';
import {type ContextualExpression} from '@packages/utilities/contextual-expression';
import {typeName, qualify} from '@packages/systems/wfdl-Qualified';

const trimActionMiddleware =
  (dispatch: (arg1?: any) => void) => (action: any) => {
    const newExpression = action.payload.newExpression;
    const text = Expressions.getText(newExpression);
    const updatedExpression = EText((text || '').trim());
    return updateExpressionEditorAction(dispatch)(updatedExpression)(action);
  };
const DisplayNameTypeRender = ({
  expr,
  dispatch,
}: {
  expr: ContextualExpression;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
}) => {
  const trimTextMiddleware = React.useMemo(
    () => trimActionMiddleware(dispatch),
    [dispatch]
  );
  return <ExpressionEditor dispatch={trimTextMiddleware} expression={expr} />;
};

export const DisplayNameType = TypeImplementation.Alias({
  type: withMeta(
    {placeholder: 'For Designer labels'},
    TTypeConstructor(qualify(Plugins.name('Basic'), typeName('OnBlurText')))
  ),
  render: DisplayNameTypeRender,
});
